const apiKeys = {
  headerButtons: {
    create: 'Erstellen',
  },
  table: {
    headers: {
      alias: 'Name',
      createdAt: 'Erstellt am',
      accessTokenExpiration: 'Sitzungsablauf',
      permissions: 'Berechtigungen',
      editable: 'Bearbeitbar',
    },
    actions: {
      delete: 'Löschen',
      generateToken: 'Token generieren',
    },
    expiration: {
      default: 'Standard',
    },
    filters: {
      editable: {
        label: 'Bearbeitbar',
        isEditable: 'Bearbeitbar',
        isNotEditable: 'Nicht bearbeitbar',
      },
    },
    permissions: {
      all: 'Voller Zugriff',
    },
    editable: {
      yes: 'Ja',
      no: 'Nein',
    },
  },
  create: {
    title: 'API-Schlüssel erstellen',
    error: 'API-Schlüssel konnte nicht erstellt werden',
    unlimitedWarning: 'Unbegrenzte Tokens bleiben aktiv, bis sie gelöscht werden. Wir empfehlen, eine Ablaufzeit festzulegen.',
    tabs: {
      info: 'Info',
      permissions: 'Berechtigungen',
    },
    expirationUnits: {
      minutes: 'Minuten',
      hours: 'Stunden',
      days: 'Tage',
      unlimited: 'Unbegrenzt',
    },
    fields: {
      alias: 'Name',
      expiresAt: 'Sitzungsablauf',
    },
  },
  newSecretModal: {
    title: 'Neuer Secret Key',
    subtitle: 'Kopieren Sie den Secret Key in die Zwischenablage und bewahren Sie ihn sicher auf.',
    warning: 'Hinweis: Nach dem Schließen des Fensters können Sie diesen Secret Key nicht erneut anzeigen.',
    secretKeyLabel: 'Secret Key',
    copy: 'Kopieren',
    copySuccess: 'In Zwischenablage kopiert',
    copyError: 'Kopieren fehlgeschlagen',
    done: 'Fertig',
  },
  delete: {
    success: 'API-Schlüssel gelöscht',
    error: 'API-Schlüssel konnte nicht gelöscht werden',
    confirmModal: {
      title: 'API-Schlüssel löschen',
      body: 'Möchten Sie "{{ alias }}" wirklich löschen? Alle aktiven Tokens, die aus diesem Schlüssel erzeugt wurden, funktionieren sofort nicht mehr.',
      bodyMany:
        'Möchten Sie {{ count }} API-Schlüssel wirklich löschen? Alle aktiven Tokens, die aus diesen Schlüsseln erzeugt wurden, funktionieren sofort nicht mehr.',
      confirm: 'Löschen',
    },
  },
  edit: {
    title: '"{{ alias }}" bearbeiten',
    success: 'API-Schlüssel aktualisiert',
    error: 'API-Schlüssel konnte nicht aktualisiert werden',
  },
  generateToken: {
    title: 'Secret Key eingeben - {{ alias }}',
    subTitle: 'Geben Sie den Secret Key ein und klicken Sie auf Generieren, um ein Token und einen Kurzcode zu erstellen.',
    successTitle: 'Neues API-Token & Kurzcode',
    submit: 'Generieren',
    cancel: 'Abbrechen',
    done: 'Fertig',
    copy: 'Kopieren',
    copySuccess: 'In Zwischenablage kopiert',
    copyError: 'Kopieren fehlgeschlagen',
    error: 'Token konnte nicht erzeugt werden',
    instructions: 'Fügen Sie Ihren gespeicherten Client Secret ein, um ein neues Zugriffstoken zu erzeugen.',
    tokenWarning: 'Hinweis: Nach dem Schließen des Fensters können Sie dieses Token nicht erneut anzeigen.',
    shortCodeWarning: 'Hinweis: Nach dem Schließen des Fensters können Sie diesen Kurzcode nicht erneut anzeigen.',
    fields: {
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Secret Key einfügen',
      token: 'Zugriffstoken',
      shortCode: 'Kurzcode',
      expiration: 'Ablauf',
      tokenInfo: 'Kopieren Sie das Token in die Zwischenablage und bewahren Sie es sicher auf.',
      shortCodeInfo: 'Kopieren Sie den Kurzcode in die Zwischenablage und bewahren Sie ihn sicher auf.',
    },
  },
};

export default apiKeys;
